"use client";

import { styled } from "@mui/system";
import { Box } from "@mui/material";
import { type PageContentBoxProps } from "@/src/_types/Page/page-props";
import {
  FONT_DISPLAY,
  FONT_TEXT,
  HEADING_SIZE,
} from "@/src/components/common/broadsheet/tokens";

const PageContentBox = styled(Box)<PageContentBoxProps>(({ theme }) => ({
  position: "relative",
  border: "none",
  borderRadius: 0,
  boxShadow: "none",
  background: "none",
  color: theme.palette.custom?.ink,
  fontFamily: FONT_TEXT,
  fontSize: "1rem",
  " img": {
    position: "relative",
    maxWidth: "100%",
  },
  "h1, h2, h3, h4, h5, h6": {
    fontFamily: FONT_DISPLAY,
    color: theme.palette.custom?.ink,
    marginBlockStart: 0,
    marginBlockEnd: ".5rem",
    textAlign: "left",
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "0.01em",
  },
  h2: { fontSize: HEADING_SIZE.section.md },
  h3: { fontSize: HEADING_SIZE.subsection.md },
  h4: { fontSize: HEADING_SIZE.minor },
  "h5, h6": { fontSize: HEADING_SIZE.minor },
  ".alert": {
    position: "relative",
    padding: "1rem",
    marginBottom: "1rem",
    border: `1px solid ${theme.palette.custom?.ruleHairline}`,
    borderRadius: 0,
  },
  "& a:not(.bf-ui):not(.bf-ui *)": {
    color: theme.palette.custom?.link,
    transition: "color ease-in-out .2s",
    textDecoration: "underline",
    textUnderlineOffset: "0.15em",
    "&:hover": {
      color: theme.palette.custom?.linkHover,
      cursor: "pointer",
    },
  },
  "& iframe": {
    border: "none",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: ".9375rem",
    h2: { fontSize: HEADING_SIZE.section.xs },
    h3: { fontSize: HEADING_SIZE.subsection.xs },
  },
}));

export default PageContentBox;
